import { BACKEND_BASE_URL } from "@/config";
import axiosClient from "../axiosClient";

const AuthServices = {
  logoutHandler: async (params: any) => {
    const response = await axiosClient.get(`${BACKEND_BASE_URL}/xsm-api-sso/v2/proxy/oidc/logout`, {
      params
    });

    return response.data;
  }
};

export default AuthServices;
